<template>
  <div>
    <h1>管理者</h1>
    <div class="btnGroup">
      <Button :to="{name: 'EditAdmin'}" type="primary">
        <Icon type="md-add" />管理員
      </Button>
    </div>
    <Table stripe border :columns="columns" :no-data-text="noDataText" :data="admins"  @on-row-click="showInfo">
      <template slot-scope="{ row }" slot="action">
        <Button type="warning" size="small">修改密碼</Button>
      </template>
    </Table>
    <div class="paginationContainer page-position">
      <Page :total="page.totalCount" :curent="page.index" :page-size="page.size" @on-change="changePage" />
    </div>
    <Modal
      v-model="isShowPasswordModal"
      title="修改密碼"
      @on-ok="submitPassword"
      @on-cancel="cancel">
      <Input
      type="password"
      v-model="adminNewPassword" placeholder="請輸入新密碼"/>
    </Modal>
  </div>
</template>

<script>
import API from "../asset/js/API"
export default {
  created () {
    this.getAdminList()
  },
  data () {
    return {
      columns: [
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '職位',
          key: 'position'
        },
        {
          title: '帳號',
          key: 'account'
        },
        {
          title: '動作',
          slot: 'action',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      this.isShowPasswordModal = true
                      this.adminId = params.row.id
                    }
                  }
                },
                "修改密碼"
              )
            ]);
          }
        }
      ],
      admins: [],
      isShowPasswordModal: false,
      adminId: null,
      adminNewPassword: null,
      noDataText: '暫無資料',
      page:{
        totalCount: 0,
        index: 1,
        size: 25
      },
    }
  },
  methods: {
    showInfo(row, index) {
      this.$router.push({ name: "AdminInfo", params: { ...row } });
    },
    changePage(page) {
      this.page.index = page
      this.getAdminList()
    },
    getAdminList() {
      API.get(`/manager/?npp=${this.page.size}&page=${this.page.index}`)
      .then(res => {
        this.admins = res.result.list
        this.totalPage = Math.ceil(this.admins.length / 25)
      })
      .catch(err => {
        console.error('取得管理員列表',err)
      })
    },
    submitPassword() {
      if(!this.adminNewPassword) {
        this.$Message.info('請填入密碼')
        return
      }
      API.put(`/manager/${this.adminId}/pw`, {password: this.adminNewPassword})
      .then(res => {
        this.adminNewPassword = null
        this.$Message.info(res.result)
      })
      .catch(err => {
        console.error('取得管理員列表',err)
      })
    },
    cancel () {
      this.adminNewPassword = null
      this.$Message.info('取消修改');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/base.scss";
@import "@/scss/pagination.scss";
.btnGroup {
  margin-bottom: 24px;
}
// 修改 iview table css，滑鼠移到 table row 時出現手指
.ivu-table-row {
  cursor: pointer;
}
.page-position{
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue